import React from 'react';

// TODO this can be a named export and typed
// oxlint-disable-next-line import/no-default-export, @typescript-eslint/no-explicit-any
export default React.createContext<any>(null);
